import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.DefaultReviewerSection', {
    addDefaultReviewer: 'Add the default Reviewer',
    addDefaultReviewerDescription:
        'A Default Reviewer is added to a step in case there is no designated Reviewer specified for it.',
});
